/**
 * tryGet - helper for accessing some value in an object or array
 *
 * @param  {Object} obj     source object or array
 * @param  {Array}  ...path array of strings,
 *                          numbers(index in array)
 *                          and functions(if you need to perform find on some step)
 *
 * @return {Any}            found value or null
 */
export function tryGet(obj, ...path) {
  try {
    let result = obj;

    let i = 0;

    while (result && i < path.length) {
      if (typeof path[i] === 'function') {
        result = path[i](result);
      } else {
        result = result[path[i]];
      }

      i += 1;
    }

    if (i === path.length) {
      return result;
    }
  } catch (e) {
    return null;
  }

  return null;
}

export function isObject(value) {
  return value !== null && typeof value === 'object';
}

export function deepMerge(...sources) {
  const returnValue = {};
  for (const source of sources) {
    for (let [key, value] of Object.entries(source)) {
      if (isObject(value) && Reflect.has(returnValue, key)) {
        value = deepMerge(returnValue[key], value);
      }

      returnValue[key] = value;
    }
  }
  return returnValue;
}
